import { ChangeEvent } from 'react';
import { Checkbox, Stack, Typography } from 'core/common/ui/ui-kit';
import { prepareHtml } from 'core/common/utils/prepareHtml';

type PolicyExtendedProps = {
  data: {
    basic: string;
    withCheckbox: string;
    withoutCheckbox: string;
    withCheckboxError: string;
  };
  className?: string;
  withoutCheckbox?: boolean;
  isError?: boolean;
  isPolicyAccepted: boolean;
  onPolicyClick: (checked: boolean) => void;
};

export const PolicyExtended = ({
  data,
  onPolicyClick,
  isPolicyAccepted,
  isError = false,
  withoutCheckbox = false,
  className,
}: PolicyExtendedProps) => {
  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    onPolicyClick(e.target.checked);
  };

  if (withoutCheckbox) {
    return (
      <Typography
        className={className}
        variant="text-body-2xs"
        color="text.secondary"
        textAlign="center"
        dangerouslySetInnerHTML={prepareHtml(data.withoutCheckbox)}
      />
    );
  }

  return (
    <Stack className={className} gap={2} alignItems="center">
      <Stack direction="row" gap={2} alignItems="center">
        <Checkbox checked={isPolicyAccepted} onChange={handleCheckboxChange} />
        <Typography
          variant="text-body-2xs"
          dangerouslySetInnerHTML={prepareHtml(data.withCheckbox)}
        />
      </Stack>
      {isError && (
        <Stack>
          <Typography
            variant="text-body-2xs"
            color="error.main"
            textAlign="center"
            dangerouslySetInnerHTML={prepareHtml(data.withCheckboxError)}
          />
        </Stack>
      )}
    </Stack>
  );
};
